export default __webpack_public_path__ + "static/Bobby_Saul-1200x800-d714bf111663579efbb0722c3a83ba40.jpg";